export function exhaustiveSwitchError(value: never): Error {
  return new Error(`Unexpected value: ${value}`)
}
